import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = "website",
  article = false,
  publishedDate,
  modifiedDate,
  author = "Kritika Goswamy Malik",
  structuredData,
}) => {
  const siteTitle = "Kritika Goswamy Malik - Interior Designer | KGM Interiors";
  const pageTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const baseUrl = "https://kritikagoswamymalik.com";
  const fullCanonicalUrl = canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl;
  const defaultImage = `${baseUrl}/og-image.jpg`;
  const imageUrl = ogImage ? `${baseUrl}${ogImage}` : defaultImage;

  const defaultKeywords =
    "Kritika Goswamy Malik, interior designer, interior design, KGM Interiors, residential design, corporate design, hospitality design, healthcare design, luxury interiors, home design, office design, spatial design, architectural design, interior decorator";
  const pageKeywords = keywords
    ? `${keywords}, ${defaultKeywords}`
    : defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={pageKeywords} />
      <meta name="author" content={author} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="KGM Interiors" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      <meta property="twitter:title" content={pageTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />
      <meta property="twitter:creator" content="@KGMInteriors" />

      {/* Article specific meta tags */}
      {article && (
        <>
          <meta property="og:type" content="article" />
          <meta property="article:author" content={author} />
          {publishedDate && (
            <meta property="article:published_time" content={publishedDate} />
          )}
          {modifiedDate && (
            <meta property="article:modified_time" content={modifiedDate} />
          )}
          <meta property="article:section" content="Interior Design" />
          <meta property="article:tag" content="Interior Design" />
        </>
      )}

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
